import axios from "axios";

const instance = axios.create({
  baseURL: "https://sistemas.mindef.gob.bo/reafucb/api",
  //baseURL: "http://192.168.20.31:9097/api",
  //baseURL: "http://127.0.0.1:8000/api",
});

instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  });
  
  export default instance;

